import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import NavigationAppShell from '../../common/navigation-app-shell'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import * as emailActions from '../../store/email'
import * as subscriptionActions from '../../store/subscriptions'
import Styles from '../../common/styles'
import Y from '../../y18n'

const mapStateToProps = state => ({
  accounts: state.accounts,
  locales: state.locales,
  subscriptions: state.subscriptions,
  email: state.email
})

const mapDispatchToProps = dispatch => ({
  emailActions: bindActionCreators(emailActions, dispatch),
  subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
})

const questionTypes = [
  { value: 'General', label: 'General question' },
  { value: 'Subscription', label: 'Subscription question' }
]

class ContactPage extends Component {
  state = {
    imsis: [],
    questionType: 'General',
    selectedImsi: '',
    email: '',
    subject: '',
    content: '',
    language: '',
    country: '',
    disabled: true
  }

  componentDidMount () {
    let imsis = []
    this.props.accounts.isAuthenticated
      ? this.props.subscriptionActions.getSubscriptions().then(res => {
        this.props.subscriptions.items.map(item => imsis.push(`${item.imsi} - ${item.name}`))
        this.setState({
          imsis: imsis,
          selectedImsi: imsis.length ? imsis[0] : '',
          email: this.props.accounts.profile.email,
          language: this.props.locales.language,
          country: this.props.locales.country
        })
      })
      : this.setState({
        language: this.props.locales.language,
        country: this.props.locales.country
      })
  }

  handleSubmit = e => {
    e.preventDefault()
    let command = {
      senderEmail: this.state.email,
      subject: this.state.subject,
      content: this.state.content,
      imsi: this.state.questionType === 'Subscription' ? this.state.selectedImsi.split(' - ')[0] : '',
      language: this.state.language,
      country: this.state.country
    }
    this.setState({ subject: '', content: '', questionType: 'General', disabled: true })
    this.props.emailActions.sendContactEmail(command)
  }

  handleChange = name => e => {
    this.setState({ [name]: e.target.value, disabled: false })
  }

  backToSupport () {
    this.props.history.push('/support')
  }

  render () {
    const { accounts, classes } = this.props
    return accounts.isAuthenticated
      ? <NavigationAppShell content={this.renderContactContent()} pageName={'Contact us'} />
      : <TopNavigationAppShell
        content={<div className={classes.topNavContent}>{this.renderContactContent()}</div>}
        pageName={'Contact us'}
        startPage={false}
        />
  }

  renderContactContent () {
    const { classes, accounts } = this.props
    const topMargin = accounts.isAuthenticated ? '0px' : '20px'
    return (
      <Paper style={{ marginTop: topMargin }}>
        {this.props.email.loading && <LinearProgress />}
        <div className={classes.content}>
          <div className={classes.textRow}>
            <Typography variant='title'>
              {Y`Contact us with questions or feedback`}
            </Typography>
            <Typography variant='body2'>
              {Y`Please provide as much details as possible about your support case to make it easier for us to help you`}
            </Typography>
          </div>
          <form onSubmit={e => this.handleSubmit(e)}>
            <TextField
              margin='normal'
              label={Y`Your Email address`}
              type='email'
              value={this.state.email || ''}
              onChange={this.handleChange('email')}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              required
              fullWidth
            />
            <TextField
              select
              label={Y`Question type`}
              value={this.state.questionType}
              onChange={this.handleChange('questionType')}
              SelectProps={{
                native: true
              }}
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.root,
                  input: classes.input
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.formLabel
              }}
              margin='normal'
              fullWidth
            >
              {questionTypes.map(type => (
                <option key={type.value} value={type.value}>
                  {Y`${type.label}`}
                </option>
              ))}
            </TextField>
            {this.state.questionType === 'Subscription' &&
              <TextField
                select
                label={Y`IMSI`}
                value={this.state.selectedImsi}
                onChange={this.handleChange('selectedImsi')}
                SelectProps={{
                  native: true
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                helperText={Y`Select which IMSI number this question is regarding`}
                margin='normal'
                fullWidth
              >
                {this.state.imsis.map(imsi => (
                  <option key={imsi} value={imsi}>
                    {Y`${imsi}`}
                  </option>
                ))}
              </TextField>}
            <div style={{ marginTop: '50px' }}>
              <TextField
                margin='normal'
                label={Y`Subject`}
                type='text'
                value={this.state.subject}
                onChange={this.handleChange('subject')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                required
                fullWidth
              />
              <TextField
                margin='normal'
                label={Y`Question or feedback`}
                type='text'
                value={this.state.content}
                onChange={this.handleChange('content')}
                multiline
                rows='20'
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                required
                fullWidth
              />
            </div>
            <div className={classes.buttonRow}>
              <Button
                style={{ marginRight: '10px' }}
                tabIndex={-1}
                onClick={() => this.backToSupport()}
              >{Y`Go back to the support page`}</Button>
              <Button
                variant='raised'
                color='primary'
                style={{ color: '#fff' }}
                type='submit'
                disabled={this.state.disabled}
              >{Y`Send Email`}</Button>
            </div>
          </form>
        </div>
      </Paper>
    )
  }
}

ContactPage = connect(mapStateToProps, mapDispatchToProps)(ContactPage)
export default withStyles(Styles)(ContactPage)



// WEBPACK FOOTER //
// ./src/pages/support/contact.js